import { render } from "./TimeOutAlert.vue?vue&type=template&id=45c1971a&ts=true"
import script from "./TimeOutAlert.ts?vue&type=script&lang=ts&external"
export * from "./TimeOutAlert.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__